import { render, staticRenderFns } from "./AtivaOuDesativa.vue?vue&type=template&id=7e2add53"
import script from "./AtivaOuDesativa.vue?vue&type=script&lang=js"
export * from "./AtivaOuDesativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports